<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a country drop down
    *
    * @since 20200414
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span>
        <select :name="name" :value="actualValue" v-on:input="update_coun($event)" :style="style" :class="class_ac">
            <option v-for="coun in countries" :key="coun.id" :value="coun.name">{{coun.name}}</option>
        </select>
    </span>
</template>

<script>
    export default {
        props: {
            //the name of the input
            name: {
                type: String,
                default: ''
            },
            //the value
            value: {
                default: 'United Kingdom'
            },
            //the width
            width: {
                default: ''
            },
            //the width
            class_ac: {
                default: function(){return ['form-control']}
            }
        },
        data() {
            return {
                country_data: this.value,
            };
        },
        computed: {
            actualValue: function() {
                if(this.country_data == 'UK' || this.country_data == 'England' || this.country_data == 'Wales' || this.country_data == 'Scotland'){
                    return 'United Kingdom';
                } else {
                    return this.country_data;
                }
            },
            /**
             * returns country list
             * 
             * @return Array the list
             */
            countries: function () {
                var arr = [];
                arr.push({name: 'Afghanistan',id: 1});
                arr.push({name: 'Albania',id: 2});
                arr.push({name: 'Algeria',id: 3});
                arr.push({name: 'Andorra',id: 4});
                arr.push({name: 'Angola',id: 5});
                arr.push({name: 'Antigua and Barbuda',id: 6});
                arr.push({name: 'Argentina',id: 7});
                arr.push({name: 'Armenia',id: 8});
                arr.push({name: 'Australia',id: 9});
                arr.push({name: 'Austria',id: 10});
                arr.push({name: 'Azerbaijan',id: 11});
                arr.push({name: 'Bahamas',id: 12});
                arr.push({name: 'Bahrain',id: 13});
                arr.push({name: 'Bangladesh',id: 14});
                arr.push({name: 'Barbados',id: 15});
                arr.push({name: 'Belarus',id: 16});
                arr.push({name: 'Belgium',id: 17});
                arr.push({name: 'Belize',id: 18});
                arr.push({name: 'Benin',id: 19});
                arr.push({name: 'Bhutan',id: 20});
                arr.push({name: 'Bolivia',id: 21});
                arr.push({name: 'Bosnia and Herzegovina',id: 22});
                arr.push({name: 'Botswana',id: 23});
                arr.push({name: 'Brazil',id: 24});
                arr.push({name: 'Brunei',id: 25});
                arr.push({name: 'Bulgaria',id: 26});
                arr.push({name: 'Burkina Faso',id: 27});
                arr.push({name: 'Burundi',id: 28});
                arr.push({name: "Côte d'Ivoire",id: 29});
                arr.push({name: 'Cabo Verde',id: 30});
                arr.push({name: 'Cambodia',id: 31});
                arr.push({name: 'Cameroon',id: 32});
                arr.push({name: 'Canada',id: 33});
                arr.push({name: 'Central African Republic',id: 34});
                arr.push({name: 'Chad',id: 35});
                arr.push({name: 'Chile',id: 36});
                arr.push({name: 'China',id: 37});
                arr.push({name: 'Colombia',id: 38});
                arr.push({name: 'Comoros',id: 39});
                arr.push({name: 'Congo (Congo-Brazzaville)',id: 40});
                arr.push({name: 'Costa Rica',id: 41});
                arr.push({name: 'Croatia',id: 42});
                arr.push({name: 'Cuba',id: 43});
                arr.push({name: 'Cyprus',id: 44});
                arr.push({name: 'Czechia (Czech Republic)',id: 45});
                arr.push({name: 'Democratic Republic of the Congo',id: 46});
                arr.push({name: 'Denmark',id: 47});
                arr.push({name: 'Djibouti',id: 48});
                arr.push({name: 'Dominica',id: 49});
                arr.push({name: 'Dominican Republic',id: 50});
                arr.push({name: 'Ecuador',id: 51});
                arr.push({name: 'Egypt',id: 52});
                arr.push({name: 'El Salvador',id: 53});
                arr.push({name: 'Equatorial Guinea',id: 54});
                arr.push({name: 'Eritrea',id: 55});
                arr.push({name: 'Estonia',id: 56});
                arr.push({name: 'Eswatini (fmr. "Swaziland")',id: 57});
                arr.push({name: 'Ethiopia',id: 58});
                arr.push({name: 'Fiji',id: 59});
                arr.push({name: 'Finland',id: 60});
                arr.push({name: 'France',id: 61});
                arr.push({name: 'Gabon',id: 62});
                arr.push({name: 'Gambia',id: 63});
                arr.push({name: 'Georgia',id: 64});
                arr.push({name: 'Germany',id: 65});
                arr.push({name: 'Ghana',id: 66});
                arr.push({name: 'Greece',id: 67});
                arr.push({name: 'Grenada',id: 68});
                arr.push({name: 'Guatemala',id: 69});
                arr.push({name: 'Guinea',id: 70});
                arr.push({name: 'Guinea-Bissau',id: 71});
                arr.push({name: 'Guyana',id: 72});
                arr.push({name: 'Haiti',id: 73});
                arr.push({name: 'Holy See',id: 74});
                arr.push({name: 'Honduras',id: 75});
                arr.push({name: 'Hungary',id: 76});
                arr.push({name: 'Iceland',id: 77});
                arr.push({name: 'India',id: 78});
                arr.push({name: 'Indonesia',id: 79});
                arr.push({name: 'Iran',id: 80});
                arr.push({name: 'Iraq',id: 81});
                arr.push({name: 'Ireland',id: 82});
                arr.push({name: 'Israel',id: 83});
                arr.push({name: 'Italy',id: 84});
                arr.push({name: 'Jamaica',id: 85});
                arr.push({name: 'Japan',id: 86});
                arr.push({name: 'Jordan',id: 87});
                arr.push({name: 'Kazakhstan',id: 88});
                arr.push({name: 'Kenya',id: 89});
                arr.push({name: 'Kiribati',id: 90});
                arr.push({name: 'Kuwait',id: 91});
                arr.push({name: 'Kyrgyzstan',id: 92});
                arr.push({name: 'Laos',id: 93});
                arr.push({name: 'Latvia',id: 94});
                arr.push({name: 'Lebanon',id: 95});
                arr.push({name: 'Lesotho',id: 96});
                arr.push({name: 'Liberia',id: 97});
                arr.push({name: 'Libya',id: 98});
                arr.push({name: 'Liechtenstein',id: 99});
                arr.push({name: 'Lithuania',id: 100});
                arr.push({name: 'Luxembourg',id: 101});
                arr.push({name: 'Madagascar',id: 102});
                arr.push({name: 'Malawi',id: 103});
                arr.push({name: 'Malaysia',id: 104});
                arr.push({name: 'Maldives',id: 105});
                arr.push({name: 'Mali',id: 106});
                arr.push({name: 'Malta',id: 107});
                arr.push({name: 'Marshall Islands',id: 108});
                arr.push({name: 'Mauritania',id: 109});
                arr.push({name: 'Mauritius',id: 110});
                arr.push({name: 'Mexico',id: 111});
                arr.push({name: 'Micronesia',id: 112});
                arr.push({name: 'Moldova',id: 113});
                arr.push({name: 'Monaco',id: 114});
                arr.push({name: 'Mongolia',id: 115});
                arr.push({name: 'Montenegro',id: 116});
                arr.push({name: 'Morocco',id: 117});
                arr.push({name: 'Mozambique',id: 118});
                arr.push({name: 'Myanmar (formerly Burma)',id: 119});
                arr.push({name: 'Namibia',id: 120});
                arr.push({name: 'Nauru',id: 121});
                arr.push({name: 'Nepal',id: 122});
                arr.push({name: 'Netherlands',id: 123});
                arr.push({name: 'New Zealand',id: 124});
                arr.push({name: 'Nicaragua',id: 125});
                arr.push({name: 'Niger',id: 126});
                arr.push({name: 'Nigeria',id: 127});
                arr.push({name: 'North Korea',id: 128});
                arr.push({name: 'North Macedonia',id: 129});
                arr.push({name: 'Norway',id: 130});
                arr.push({name: 'Oman',id: 131});
                arr.push({name: 'Pakistan',id: 132});
                arr.push({name: 'Palau',id: 133});
                arr.push({name: 'Palestine State',id: 134});
                arr.push({name: 'Panama',id: 135});
                arr.push({name: 'Papua New Guinea',id: 136});
                arr.push({name: 'Paraguay',id: 137});
                arr.push({name: 'Peru',id: 138});
                arr.push({name: 'Philippines',id: 139});
                arr.push({name: 'Poland',id: 140});
                arr.push({name: 'Portugal',id: 141});
                arr.push({name: 'Qatar',id: 142});
                arr.push({name: 'Romania',id: 143});
                arr.push({name: 'Russia',id: 144});
                arr.push({name: 'Rwanda',id: 145});
                arr.push({name: 'Saint Kitts and Nevis',id: 146});
                arr.push({name: 'Saint Lucia',id: 147});
                arr.push({name: 'Saint Vincent and the Grenadines',id: 148});
                arr.push({name: 'Samoa',id: 149});
                arr.push({name: 'San Marino',id: 150});
                arr.push({name: 'Sao Tome and Principe',id: 151});
                arr.push({name: 'Saudi Arabia',id: 152});
                arr.push({name: 'Senegal',id: 153});
                arr.push({name: 'Serbia',id: 154});
                arr.push({name: 'Seychelles',id: 155});
                arr.push({name: 'Sierra Leone',id: 156});
                arr.push({name: 'Singapore',id: 157});
                arr.push({name: 'Slovakia',id: 158});
                arr.push({name: 'Slovenia',id: 159});
                arr.push({name: 'Solomon Islands',id: 160});
                arr.push({name: 'Somalia',id: 161});
                arr.push({name: 'South Africa',id: 162});
                arr.push({name: 'South Korea',id: 163});
                arr.push({name: 'South Sudan',id: 164});
                arr.push({name: 'Spain',id: 165});
                arr.push({name: 'Sri Lanka',id: 166});
                arr.push({name: 'Sudan',id: 167});
                arr.push({name: 'Suriname',id: 168});
                arr.push({name: 'Sweden',id: 169});
                arr.push({name: 'Switzerland',id: 170});
                arr.push({name: 'Syria',id: 171});
                arr.push({name: 'Tajikistan',id: 172});
                arr.push({name: 'Tanzania',id: 173});
                arr.push({name: 'Thailand',id: 174});
                arr.push({name: 'Timor-Leste',id: 175});
                arr.push({name: 'Togo',id: 176});
                arr.push({name: 'Tonga',id: 177});
                arr.push({name: 'Trinidad and Tobago',id: 178});
                arr.push({name: 'Tunisia',id: 179});
                arr.push({name: 'Turkey',id: 180});
                arr.push({name: 'Turkmenistan',id: 181});
                arr.push({name: 'Tuvalu',id: 182});
                arr.push({name: 'Uganda',id: 183});
                arr.push({name: 'Ukraine',id: 184});
                arr.push({name: 'United Arab Emirates',id: 185});
                arr.push({name: 'United Kingdom',id: 186});
                arr.push({name: 'United States of America',id: 187});
                arr.push({name: 'Uruguay',id: 188});
                arr.push({name: 'Uzbekistan',id: 189});
                arr.push({name: 'Vanuatu',id: 190});
                arr.push({name: 'Venezuela',id: 191});
                arr.push({name: 'Vietnam',id: 192});
                arr.push({name: 'Yemen',id: 193});
                arr.push({name: 'Zambia',id: 194});
                arr.push({name: 'Zimbabwe' ,id: 195});
                return arr;
            },
            /**
             * the style params
             * 
             * @return String the style params
             */
            style: function () {
                var sty = {};
                if(this.width != ''){
                    sty.width = this.width;
                }
                return sty;
            },
        },
        methods: {
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_coun: function (value) {
                this.country_data = value.target.value;
                this.$emit('input',this.country_data);
            },
        }
    }
</script>
